module.exports = __webpack_public_path__ + "static/media/2.14b5a260.jpg";